import classNames from "classnames";
import React, { FC } from "react";
import { useAppContext } from "../../../hooks/useAppContext";
import { useProductStartDate } from "../../../hooks/useProductStartDate";
import { useProductStartDates } from "../../../hooks/useProductStartDates";

import { TransparentButton } from "../../transparent-button";
import "./start-date-option.css";

type StartDateOptionProps = {
	startDate: eXpress.DateMonthString;
	type: "month" | "year";
};

export const StartDateOption: FC<StartDateOptionProps> = ({ startDate, type }) => {
	const selectedStartDate = useProductStartDate();
	const [, changeStartDate] = useProductStartDates();
	const {
		context: { language },
	} = useAppContext();

	const isActive = selectedStartDate === startDate;
	const months = eXpress.getLocalizedMonthNames(language);
	const jsStartDate = eXpress.DateMonthString.toDate(startDate);
	const dateString =
		type === "year"
			? `${jsStartDate.getFullYear()}`
			: `${months[jsStartDate.getMonth()]} ${jsStartDate.getFullYear()}`;

	return (
		<TransparentButton
			className={classNames("start-date-option", {
				"start-date-option--active": isActive,
			})}
			onClick={() => {
				// eslint-disable-next-line @typescript-eslint/no-floating-promises
				changeStartDate?.(startDate);
			}}
		>
			<div className="start-date-option__content">
				<span className="start-date-option__text">{dateString}</span>
			</div>
		</TransparentButton>
	);
};
